import { useEffect, useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import CookieBanner from '../../components/feature/CookieBanner';

const faqs = [
  {
    question: '¿Cuánto cuesta el vaciado de un piso en Vic?',
    answer: 'El precio del vaciado de un piso depende de varios factores: tamaño de la vivienda, cantidad de muebles y enseres, accesibilidad (si hay ascensor o no), y el estado de limpieza. En JUSTCLEAN VIC ofrecemos presupuestos personalizados sin compromiso. Llámanos al 602 36 59 96 o escríbenos por WhatsApp y te daremos un precio ajustado a tus necesidades. Trabajamos en Vic, Manlleu, Torelló y toda la comarca de Osona con tarifas competitivas y transparentes.',
  },
  {
    question: '¿En cuánto tiempo podéis vaciar un piso o local?',
    answer: 'El tiempo necesario para vaciar un piso o local varía según el tamaño y la cantidad de contenido. Un piso estándar de 2-3 habitaciones suele vaciarse en 1 día. Locales comerciales pueden requerir entre 1 y 3 días dependiendo del volumen. Ofrecemos servicio urgente 24 horas para casos que requieren rapidez. En casos de síndrome de Diógenes o suciedad extrema, el plazo puede ser mayor debido a la necesidad de limpieza profunda y desinfección. Te informamos del plazo exacto en el presupuesto.',
  },
  {
    question: '¿Cómo gestionáis los residuos y muebles retirados?',
    answer: 'Gestionamos todos los residuos de forma completamente legal y responsable con el medio ambiente. Los muebles y electrodomésticos en buen estado se donan a organizaciones benéficas o se llevan a puntos de reciclaje autorizados. Los residuos se clasifican y se transportan a los centros de tratamiento correspondientes según la normativa vigente. Disponemos de todos los permisos necesarios para la gestión de residuos en Vic y comarca de Osona. Tú no tienes que preocuparte de nada, nosotros nos encargamos de todo el proceso.',
  },
  {
    question: '¿Ofrecéis servicio discreto para casos de síndrome de Diógenes?',
    answer: 'Sí, la discreción y confidencialidad son fundamentales en nuestro trabajo, especialmente en casos de síndrome de Diógenes. Nuestro equipo está específicamente formado para tratar estas situaciones delicadas con el máximo respeto y sensibilidad. Trabajamos con vehículos sin rotulación si es necesario, coordinamos horarios para evitar coincidencias con vecinos, y mantenemos absoluta confidencialidad sobre el caso. Entendemos la complejidad emocional de estas situaciones y ofrecemos un trato empático y profesional. Colaboramos con servicios sociales y familiares cuando es necesario.',
  },
  {
    question: '¿Trabajáis en toda la comarca de Osona?',
    answer: 'Sí, ofrecemos nuestros servicios de vaciado de pisos, vaciado de locales, limpieza por síndrome de Diógenes y retirada de muebles en toda la comarca de Osona. Trabajamos habitualmente en Vic (Centre Històric, El Remei, Horta Vermella, Estadi, Vic Sud, Serra-de-senferm, Caputxins), Manlleu, Torelló, Taradell, Tona, Gurb, Calldetenes, Roda de Ter, Folgueroles y localidades cercanas. Si tu zona no aparece en la lista, consúltanos sin compromiso y te informaremos sobre la disponibilidad del servicio.',
  },
  {
    question: '¿Cómo coordinamos el trabajo con los vecinos de la comunidad?',
    answer: 'Entendemos la importancia de mantener buenas relaciones con la comunidad de vecinos. Antes de iniciar el trabajo, coordinamos horarios para minimizar molestias, protegemos zonas comunes (escaleras, ascensor, portal) con materiales adecuados para evitar daños, trabajamos de forma ordenada y limpia, y respetamos los horarios de descanso establecidos por la comunidad. Si es necesario, nos coordinamos con el administrador de fincas. En casos que requieren discreción, adaptamos nuestro método de trabajo para ser lo más discretos posible. Nuestro objetivo es realizar el vaciado sin causar inconvenientes a los vecinos.',
  },
  {
    question: '¿Qué diferencia hay entre vaciado y limpieza extrema?',
    answer: 'El vaciado de pisos consiste en retirar todos los muebles, enseres y electrodomésticos de una vivienda o local, dejando el espacio vacío. Incluye una limpieza básica final. La limpieza extrema es un servicio especializado para espacios con suciedad acumulada, malos olores, manchas difíciles o casos de síndrome de Diógenes. Incluye desinfección profunda, eliminación de olores, limpieza de paredes, suelos y techos con productos profesionales. Muchos clientes contratan ambos servicios: primero el vaciado y después la limpieza extrema para dejar el espacio completamente habitable. Podemos ofrecerte un paquete combinado con precio especial.',
  },
  {
    question: '¿Recogéis muebles sueltos o hay un servicio mínimo?',
    answer: 'Para el servicio de retirada de muebles y electrodomésticos, tenemos un servicio mínimo de una furgoneta llena. No recogemos muebles sueltos individuales como una sola mesa, una butaca o una silla. Este servicio está pensado para retiradas de volumen considerable: varios muebles, electrodomésticos, vaciado parcial de viviendas o trasteros. Si necesitas vaciar completamente un piso, local o trastero, no hay problema de volumen mínimo. Si tienes dudas sobre si tu caso cumple el mínimo, llámanos al 602 36 59 96 y te asesoramos sin compromiso.',
  },
];

export default function FaqPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    document.title = 'Preguntas Frecuentes - Vaciado de Pisos Vic | JUSTCLEAN VIC';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Resuelve tus dudas sobre vaciado de pisos, limpieza Diógenes y retirada de muebles en Vic. Precios, plazos, gestión de residuos y más. ☎️ 602 36 59 96'
      );
    }

    // Add FAQ Schema
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="py-20 bg-gradient-to-br from-secondary/10 to-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h1 className="text-4xl sm:text-5xl font-bold text-dark mb-6">
                Preguntas frecuentes
              </h1>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Resuelve tus dudas sobre nuestros servicios de <strong>vaciado de pisos y locales</strong>, <strong>limpieza por síndrome de Diógenes</strong> y <strong>retirada de muebles</strong> en Vic y comarca de Osona. Si no encuentras la respuesta que buscas, no dudes en contactarnos.
              </p>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300"
                >
                  <button
                    onClick={() => toggleFaq(index)}
                    className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
                    aria-expanded={openIndex === index}
                  >
                    <h3 className="text-base font-bold text-dark pr-4">
                      {faq.question}
                    </h3>
                    <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                      <i
                        className={`ri-arrow-down-s-line text-2xl text-primary transition-transform duration-300 ${
                          openIndex === index ? 'rotate-180' : ''
                        }`}
                      ></i>
                    </div>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      openIndex === index ? 'max-h-96' : 'max-h-0'
                    }`}
                  >
                    <div className="px-6 pb-5 pt-2">
                      <p className="text-sm text-gray-700 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Más Información */}
        <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-dark mb-4">
                ¿Necesitas más información?
              </h2>
              <p className="text-base text-gray-600 max-w-3xl mx-auto">
                Si tienes alguna pregunta específica sobre nuestros servicios de <strong>vaciado de pisos en Vic</strong>, <strong>limpieza extrema</strong> o <strong>síndrome de Diógenes</strong>, estaremos encantados de atenderte personalmente.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-lg p-6 shadow-lg text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-full mx-auto mb-4">
                  <i className="ri-phone-line text-3xl text-primary"></i>
                </div>
                <h3 className="text-lg font-bold text-dark mb-3">Llámanos</h3>
                <p className="text-sm text-gray-600 mb-4">
                  Atención telefónica inmediata de lunes a sábado
                </p>
                <a
                  href="tel:+34602365996"
                  className="inline-block bg-primary text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-red-700 transition-all duration-300 text-sm whitespace-nowrap"
                >
                  602 36 59 96
                </a>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-lg text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-full mx-auto mb-4">
                  <i className="ri-whatsapp-line text-3xl text-primary"></i>
                </div>
                <h3 className="text-lg font-bold text-dark mb-3">WhatsApp</h3>
                <p className="text-sm text-gray-600 mb-4">
                  Escríbenos y te respondemos al instante
                </p>
                <a
                  href="https://wa.me/34602365996"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-green-500 text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-green-600 transition-all duration-300 text-sm whitespace-nowrap"
                >
                  Escribir ahora
                </a>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-lg text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-full mx-auto mb-4">
                  <i className="ri-mail-line text-3xl text-primary"></i>
                </div>
                <h3 className="text-lg font-bold text-dark mb-3">Email</h3>
                <p className="text-sm text-gray-600 mb-4">
                  Envíanos un correo con tu consulta
                </p>
                <a
                  href="mailto:info@vic.justclean.es"
                  className="inline-block bg-dark text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-gray-800 transition-all duration-300 text-sm whitespace-nowrap"
                >
                  Enviar email
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Temas Relacionados */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-dark mb-4">
                Temas relacionados
              </h2>
              <p className="text-base text-gray-600 max-w-3xl mx-auto">
                Descubre más información sobre nuestros servicios en Vic y Osona
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <a
                href="/servicios#vaciado-pisos"
                className="bg-gradient-to-br from-secondary/10 to-white rounded-lg p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-lg mb-4 group-hover:bg-primary/20 transition-colors">
                  <i className="ri-home-4-line text-2xl text-primary"></i>
                </div>
                <h3 className="text-base font-bold text-dark mb-2">Vaciado de pisos</h3>
                <p className="text-sm text-gray-600">
                  Información completa sobre el servicio
                </p>
              </a>

              <a
                href="/servicios#diogenes"
                className="bg-gradient-to-br from-secondary/10 to-white rounded-lg p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-lg mb-4 group-hover:bg-primary/20 transition-colors">
                  <i className="ri-heart-pulse-line text-2xl text-primary"></i>
                </div>
                <h3 className="text-base font-bold text-dark mb-2">Síndrome de Diógenes</h3>
                <p className="text-sm text-gray-600">
                  Servicio especializado y discreto
                </p>
              </a>

              <a
                href="/servicios#limpieza-extrema"
                className="bg-gradient-to-br from-secondary/10 to-white rounded-lg p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-lg mb-4 group-hover:bg-primary/20 transition-colors">
                  <i className="ri-sparkling-2-line text-2xl text-primary"></i>
                </div>
                <h3 className="text-base font-bold text-dark mb-2">Limpieza extrema</h3>
                <p className="text-sm text-gray-600">
                  Desinfección y limpieza profunda
                </p>
              </a>

              <a
                href="/empresa"
                className="bg-gradient-to-br from-secondary/10 to-white rounded-lg p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-lg mb-4 group-hover:bg-primary/20 transition-colors">
                  <i className="ri-building-line text-2xl text-primary"></i>
                </div>
                <h3 className="text-base font-bold text-dark mb-2">Sobre nosotros</h3>
                <p className="text-sm text-gray-600">
                  Conoce nuestra empresa y valores
                </p>
              </a>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-16 bg-gradient-to-br from-primary to-red-700 text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold mb-6">
              ¿Listo para solicitar tu presupuesto?
            </h2>
            <p className="text-lg mb-8 opacity-95 leading-relaxed">
              Contacta con nosotros ahora y obtén un <strong>presupuesto sin compromiso</strong> para el vaciado de tu piso o local en Vic y comarca de Osona.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:+34602365996"
                className="bg-white text-primary px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap text-sm inline-flex items-center justify-center"
              >
                <i className="ri-phone-line mr-2"></i>
                Llamar: 602 36 59 96
              </a>
              <a
                href="/contacto"
                className="bg-dark text-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap text-sm inline-flex items-center justify-center"
              >
                <i className="ri-mail-line mr-2"></i>
                Formulario de contacto
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
      <CookieBanner />
    </div>
  );
}
